"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VeilederPropsShape = void 0;
const React = __importStar(require("react"));
const PT = __importStar(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const nav_frontend_js_utils_1 = require("nav-frontend-js-utils");
require("nav-frontend-veileder-style");
const cls = (props) => (0, classnames_1.default)("nav-veileder", props.className, {
    "nav-veileder--advarsel": props.type === "advarsel",
    "nav-veileder--feilmelding": props.type === "feilmelding",
    "nav-veileder--suksess": props.type === "suksess",
    "nav-veileder--flytende": props.posisjon === "flytende",
    "nav-veileder--topp": props.posisjon === "topp",
    "nav-veileder--hoyre": props.posisjon === "høyre",
    "nav-veileder--bunn": props.posisjon === "bunn",
    "nav-veileder--venstre": props.posisjon === "venstre",
});
const frameCls = (props) => (0, classnames_1.default)("nav-veileder__frame", {
    "nav-veileder__frame--center": props.center,
    "nav-veileder__frame--transparent": props.transparent,
    "nav-veileder__frame--nomask": props.nomask,
    "nav-veileder__frame--s": props.storrelse === "S",
    "nav-veileder__frame--m": props.storrelse === "M",
    "nav-veileder__frame--l": props.storrelse === "L",
    "nav-veileder__frame--xl": props.storrelse === "XL",
    "nav-veileder__frame--info": props.fargetema === "info",
    "nav-veileder__frame--suksess": props.fargetema === "suksess",
    "nav-veileder__frame--advarsel": props.fargetema === "advarsel",
    "nav-veileder__frame--feilmelding": props.fargetema === "feilmelding",
});
const pilCls = (props) => (0, classnames_1.default)("nav-veileder__snakkeboblePil", {
    "nav-veileder__snakkeboblePil--flytende": props.posisjon === "flytende",
    "nav-veileder__snakkeboblePil--topp": props.posisjon === "topp",
    "nav-veileder__snakkeboblePil--hoyre": props.posisjon === "høyre",
    "nav-veileder__snakkeboblePil--bunn": props.posisjon === "bunn",
    "nav-veileder__snakkeboblePil--venstre": props.posisjon === "venstre",
    "nav-veileder__snakkeboblePil--hvit": props.hvitSnakkeboble,
});
const snakkebobleCls = (props) => (0, classnames_1.default)("nav-veileder__snakkeboble", {
    "nav-veileder__snakkeboble--flytende": props.posisjon === "flytende",
    "nav-veileder__snakkeboble--topp": props.posisjon === "topp",
    "nav-veileder__snakkeboble--hoyre": props.posisjon === "høyre",
    "nav-veileder__snakkeboble--bunn": props.posisjon === "bunn",
    "nav-veileder__snakkeboble--venstre": props.posisjon === "venstre",
    "nav-veileder__snakkeboble--hvit": props.hvitSnakkeboble,
});
class Veileder extends React.Component {
    render() {
        const _a = this.props, { children, tekst } = _a, other = __rest(_a, ["children", "tekst"]);
        const domProps = (0, nav_frontend_js_utils_1.omit)(Object.assign({}, other), "center", "nomask", "says", "color", "transparent", "width", "type", "fargetema", "storrelse", "posisjon", "className", "hvitSnakkeboble");
        return (React.createElement("div", Object.assign({ className: cls(this.props) }, domProps),
            React.createElement("div", { className: frameCls(this.props) }, children),
            tekst && React.createElement("i", { className: pilCls(this.props) }),
            tekst && (React.createElement("div", { className: snakkebobleCls(this.props) }, this.props.tekst))));
    }
}
Veileder.defaultProps = {
    type: "normal",
    fargetema: "normal",
    storrelse: "M",
    posisjon: "flytende",
};
exports.VeilederPropsShape = {
    /**
     * Custom SVG-element som illustrerer en figur, f.eks. en av disse:
     * https://app.zeplin.io/project/59831e455850985791bdeb4d/screen/5a7c1fcc36781f9423ab6a0e
     */
    children: PT.node,
    /**
     * Klassenavn
     */
    className: PT.string,
    /**
     * Tekst eller HTML som rendres i en snakkeboble
     */
    tekst: PT.node,
    /**
     * Skrur av bakgrunnsfargen
     */
    transparent: PT.bool,
    /**
     * Skrur av sirkulær maskering/cropping av children
     */
    nomask: PT.bool,
    /**
     * Skrur av 80% height på children, og rendrer i full høyde (hvis innholdet skal sentreres)
     */
    center: PT.bool,
    /**
     * Predefinerte nøkler for styling av snakkeboblen, avhengig av type budskap.
     */
    type: PT.oneOf(["normal", "suksess", "advarsel", "feilmelding"]),
    /**
     * Predefinerte fargetemaer som bestemmer bakgrunnsfargen på veilederen.
     */
    fargetema: PT.oneOf(["normal", "info", "suksess", "advarsel", "feilmelding"]),
    /**
     * Predefinerte størrelser
     */
    storrelse: PT.oneOf(["S", "M", "L", "XL"]),
    /**
     * Posisjon på snakkeboblen
     */
    posisjon: PT.oneOf(["flytende", "topp", "høyre", "bunn", "venstre"]),
    /**
     * Bakgrunnsfarge for snakkeboble
     */
    hvitSnakkeboble: PT.bool,
};
Veileder.propTypes = exports.VeilederPropsShape;
Veileder.defaultProps = {
    type: "normal",
    fargetema: "normal",
    storrelse: "M",
    posisjon: "flytende",
};
exports.default = Veileder;
